import TableCell from '@persona-id/design-system/components/Table/TableCell';
import { Control, Controller } from 'react-hook-form';
import styled from 'styled-components';

import FormError from 'dashboard/components/FormControls/FormError';
import FormGroup from 'dashboard/layouts/FormLayout/FormGroup';
import TableLayout, {
  TableNullState,
  TableTD,
  TableTH,
  TableTR,
} from 'dashboard/layouts/TableLayout';
import { FormUpdateWebhookData } from 'dashboard/routes/DashboardWebhooksShowRoute';
import Checkbox from 'design-system/components/Checkbox';

const StyledTableCell = styled(TableCell)`
  text-align: right;
  width: 48px;
`;

const StyledCheckbox = styled(Checkbox)`
  justify-content: center;
`;
interface WebhookBlocklistProps {
  control: Control<FormUpdateWebhookData, object>;
  errors: string[];
  disabled: boolean;
}

export default ({ control, errors, disabled }: WebhookBlocklistProps) => (
  <div>
    <FormGroup>
      <TableLayout
        isEmpty={false}
        showHeader={true}
        nullState={<TableNullState dataTestBlock='webhook-blocklist'></TableNullState>}
        headerTR={
          <>
            <TableTH>Object</TableTH>
            <TableTH>Block</TableTH>
          </>
        }
      >
        <TableTR>
          <TableTD>relationships</TableTD>
          <StyledTableCell>
            <Controller
              control={control}
              name='relationship-blocklist'
              render={({ field: { onChange, value = [] } }) => (
                <StyledCheckbox
                  aria-label='relationship-blocklist-checkbox'
                  checked={value.length !== 0}
                  disabled={disabled}
                  onChange={(e) => onChange(e.target.checked ? ['*'] : [])}
                  data-test='webhook-blocklist__relationship-blocklist--checkbox'
                ></StyledCheckbox>
              )}
            />
          </StyledTableCell>
        </TableTR>
        <TableTR>
          <TableTD>included</TableTD>
          <StyledTableCell>
            <Controller
              control={control}
              name='included-blocklist'
              render={({ field: { onChange, value = [] } }) => (
                <StyledCheckbox
                  aria-label='included-blocklist-checkbox'
                  checked={value.length !== 0}
                  disabled={disabled}
                  onChange={(e) => onChange(e.target.checked ? ['*'] : [])}
                  data-test='webhook-blocklist__included-blocklist--checkbox'
                ></StyledCheckbox>
              )}
            />
          </StyledTableCell>
        </TableTR>
      </TableLayout>
      {errors.map((error) => !!error && <FormError>{error}</FormError>)}
    </FormGroup>
  </div>
);
